import Divider from '@mui/material/Divider';
import { useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export type HydrogenValues = {
    apiSecretKey: string,
    apiKey: string,
    adminToken: string,
    storefrontToken: string,
}

type Props =
    {
        friendlyName: string,
        values: HydrogenValues,
        onChange: (field: keyof HydrogenValues, value: string) => void,
    }

export default function StoreHydrogenForm({ friendlyName, values, onChange }: Props) {
    const [showSecret, setShowSecret] = useState(false);
    const [showAdminToken, setShowAdminToken] = useState(false);
    const [showStorefrontToken, setShowStorefrontToken] = useState(false);

    return (
        <div className="sync-management">
            <div className="sync-header">
                <p>Shopify Stores/{friendlyName}</p>
                <h1> <img src="https://cdn.shopify.com/s/files/1/0622/8577/5024/files/hidro.png?v=1696262901" alt="" />Shopify Hydrogen</h1>
            </div>
            <Divider className="divider" />
            <div className="form-container">
                <div className="column">
                    <div className="field">
                        <p className="field-label">Application Client Secret</p>
                        <div className="field-edit">
                            <input
                                type={showSecret ? 'text' : 'password'}
                                id="hydrogenSecret"
                                value={values.apiSecretKey}
                                onChange={(e) => onChange('apiSecretKey', e.target.value)} />
                            <button type="button" onClick={() => setShowSecret(!showSecret)}>
                                {showSecret ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </div>
                    </div>
                    <div className="field">
                        <p className="field-label">Application Client Key</p>
                        <div className="field-edit">
                            <input
                                type="text"
                                id="hydrogenKey"
                                value={values.apiKey}
                                onChange={(e) => onChange('apiKey', e.target.value)} />
                        </div>
                    </div>
                    <div className="field">
                        <p className="field-label">Admin API Token</p>
                        <div className="field-edit">
                            <input
                                type={showAdminToken ? 'text' : 'password'}
                                id="hydrogenAdminToken"
                                value={values.adminToken}
                                onChange={(e) => onChange('adminToken', e.target.value)} />
                            <button type="button" onClick={() => setShowAdminToken(!showAdminToken)}>
                                {showAdminToken ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </div>
                    </div>
                    <div className="field">
                        <p className="field-label">Storefront API Token</p>
                        <div className="field-edit">
                            <input
                                type={showStorefrontToken ? 'text' : 'password'}
                                id="hydrogenStorefrontToken"
                                value={values.storefrontToken}
                                onChange={(e) => onChange('storefrontToken', e.target.value)} />
                            <button type="button" onClick={() => setShowStorefrontToken(!showStorefrontToken)}>
                                {showStorefrontToken ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}